import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root',
})
export class LeadService {
    constructor(private http: HttpClient) {}

    // Get Alert List
    getLeads(params: { page?: number; sortBy?: string; sortDir?: string } = {}) {
        const httpParams = this.buildLeadParams(params);
        return this.http.get<Array<Object>>(
            `${environment.api_url}`+'/leads',
            { params: httpParams }
        );
    }

    getProcessedLeads(params: { page?: number; sortBy?: string; sortDir?: string } = {}) {
        const httpParams = this.buildLeadParams(params);
        return this.http.get<Array<Object>>(
            `${environment.api_url}`+'/leads/processed',
            { params: httpParams }
        );
    }

    getDeletedLeads(params: { page?: number; sortBy?: string; sortDir?: string } = {}) {
        const httpParams = this.buildLeadParams(params);
        return this.http.get<Array<Object>>(
            `${environment.api_url}`+'/leads/deleted',
            { params: httpParams }
        );
    }

    private buildLeadParams(params: { page?: number; sortBy?: string; sortDir?: string }): HttpParams {
        let httpParams = new HttpParams();

        if (params.page) {
            httpParams = httpParams.set('page', params.page.toString());
        }

        if (params.sortBy) {
            httpParams = httpParams.set('sort_by', params.sortBy);
        }

        if (params.sortDir) {
            httpParams = httpParams.set('sort_dir', params.sortDir);
        }

        return httpParams;
    }
}
